function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bar-chart_svg__clip0_242_46753)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.836 6.103h-3.31c-.304 0-.55.351-.55.785v10.318h4.411V6.888c0-.434-.247-.785-.551-.785zM17.424 1.434H14.04c-.304 0-.551.35-.551.783v14.989h4.485V2.217c0-.433-.246-.783-.551-.783z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.527 18.309H1.357V1.139a.551.551 0 10-1.102 0V18.86c0 .305.246.552.551.552h17.72a.551.551 0 100-1.103z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.32 9.412H3.013c-.305 0-.552.344-.552.769v7.025h4.412V10.18c0-.425-.246-.77-.551-.77z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "bar-chart_svg__clip0_242_46753"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.255 .588)",
  d: "M0 0h18.823v18.823H0z"
})));

function SvgBarChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgBarChart;